/**
 * 物件一覧: エリア選択 → PC サイドバー / SP 条件表示（、区切り横並び）
 */
const AREA_FIELD_SELECTOR = '.bukkenListAreaModal__areaFields';
const AREA_INPUT_SELECTOR = 'input[name="area[]"]';

function collectCheckedAreaNames(root) {
	if (!root) return [];
	const seen = new Set();
	const names = [];
	root.querySelectorAll(`${AREA_INPUT_SELECTOR}:checked`).forEach((input) => {
		if (seen.has(input.value)) return;
		seen.add(input.value);
		const item = input.closest('.searchSelect__areaItem');
		const nameEl = item?.querySelector('.searchSelect__areaItemName');
		const name = nameEl?.textContent?.trim() ?? '';
		if (name) names.push(name);
	});
	return names;
}

function collectCheckedAreaValues(root) {
	if (!root) return [];
	const seen = new Set();
	const values = [];
	root.querySelectorAll(`${AREA_INPUT_SELECTOR}:checked`).forEach((input) => {
		if (seen.has(input.value)) return;
		seen.add(input.value);
		values.push(input.value);
	});
	return values;
}

/** 同一 value の checkbox が都道府県ブロックごとに複数あるため、root 内では value ごとに先頭1件だけ checked にする */
function syncAreaCheckboxes(selectedValues) {
	const set = new Set(selectedValues);
	document.querySelectorAll(AREA_FIELD_SELECTOR).forEach((root) => {
		const inputs = Array.from(root.querySelectorAll(AREA_INPUT_SELECTOR));
		inputs.forEach((input) => {
			input.checked = false;
		});
		set.forEach((value) => {
			const match = inputs.find((input) => input.value === value);
			if (match) match.checked = true;
		});
	});
}

function renderAreaLabels(container, names) {
	if (!container) return;
	container.replaceChildren();
	if (!names.length) {
		container.textContent = '—';
		return;
	}
	names.forEach((name, index) => {
		if (index > 0) {
			const sep = document.createElement('span');
			sep.className = 'bukkenList__filterValueSep';
			sep.textContent = '、';
			container.appendChild(sep);
		}
		const item = document.createElement('span');
		item.className = 'bukkenList__filterValueItem';
		item.textContent = name;
		container.appendChild(item);
	});
}

function getAreaFieldRoot(form) {
	if (!form) return null;
	return (
		form.querySelector(AREA_FIELD_SELECTOR) ||
		form.querySelector('[id$="-area-modal-fields"]') ||
		form.querySelector('[id$="-area-fields"]')
	);
}

function closeModal(modal) {
	if (!modal || modal.hasAttribute('hidden')) return;
	modal.setAttribute('hidden', '');
	document.body.style.overflow = '';
}

function closeModalContaining(form) {
	if (!form) return;
	closeModal(form.closest('.bukkenListAreaModal, .bukkenListSpFilterModal'));
}

export function initBukkenListAreaLabels() {
	const labelEls = document.querySelectorAll('[data-bukken-area-label]');
	if (!labelEls.length) return;

	const areaFieldRoots = document.querySelectorAll(AREA_FIELD_SELECTOR);

	function applyAreaSelection(root) {
		const names = collectCheckedAreaNames(root);
		const values = collectCheckedAreaValues(root);
		syncAreaCheckboxes(values);
		labelEls.forEach((el) => renderAreaLabels(el, names));
	}

	const initialRoot =
		document.getElementById('bukken-list-area-modal-fields') ||
		document.getElementById('bukken-list-investment-pc-area-fields') ||
		areaFieldRoots[0];
	if (initialRoot) applyAreaSelection(initialRoot);

	const formIds = [
		'bukken-list-area-modal-form',
		'bukken-list-sp-filter-form',
		'bukken-list-investment-pc-modal-form',
		'bukken-list-sp-investment-filter-form',
	];

	formIds.forEach((id) => {
		const form = document.getElementById(id);
		if (!form) return;
		form.addEventListener('submit', (e) => {
			e.preventDefault();
			const areaRoot = getAreaFieldRoot(form);
			if (areaRoot) applyAreaSelection(areaRoot);
			closeModalContaining(form);
		});
	});

	document.querySelectorAll('.bukkenList__sideFilters .bukkenList__searchBtn').forEach((btn) => {
		btn.addEventListener('click', () => {
			const root =
				document.getElementById('bukken-list-area-modal-fields') ||
				document.getElementById('bukken-list-investment-pc-area-fields') ||
				areaFieldRoots[0];
			if (root) applyAreaSelection(root);
		});
	});
}
